<template>
  <div>
    <div class="card-body p-0" v-loading="loading">
      <b-col md="12" class="p-0">
        <b-tabs
          card
          pills
          vertical
          nav-wrapper-class="w-40"
          v-model="tabIndex[1]"
        >
          <b-tab active>
            <template slot="title">Thông tin bệnh</template>
            <b-row>
              <b-col md="12">
                <span class="bold-500 color-black">Thời gian:</span>
                {{
                  mData.dataForm.Benh.ngay_bat_dau !=
                  mData.dataForm.Benh.ngay_ket_thuc
                    ? mData.dataForm.Benh.ngay_bat_dau +
                      " - " +
                      mData.dataForm.Benh.ngay_ket_thuc
                    : mData.dataForm.Benh.ngay_bat_dau
                }}
              </b-col>
              <b-col md="12">
                <span class="bold-500 color-black"
                  >Số ngày khám chữa bệnh:</span
                >
                {{ mData.dataForm.Benh.so_ngay_kcb + " ngày" }}
              </b-col>
              <b-col md="12">
                <span class="bold-500 color-black">Cơ sở y tế:</span>
                {{ mData.dataForm.Benh.noi_kham }}
              </b-col>
              <b-col md="12">
                <span class="bold-500 color-black">Bệnh chính:</span>
                {{
                  mData.dataForm.Benh.danh_sach_benh &&
                  mData.dataForm.Benh.danh_sach_benh[0]
                    ? mData.dataForm.Benh.danh_sach_benh[0]
                    : ""
                }}
              </b-col>
              <b-col
                md="12"
                v-if="
                  mData.dataForm.Benh.danh_sach_benh_kem_theo &&
                  mData.dataForm.Benh.danh_sach_benh_kem_theo.length > 0
                "
              >
                <span class="bold-500 color-black">Bệnh kèm theo:</span>
                <span
                  v-for="(benh, i) of mData.dataForm.Benh
                    .danh_sach_benh_kem_theo"
                  :key="i"
                >
                  <p style="margin-bottom: 0">{{ "+ " + benh }}</p>
                </span>
              </b-col>
              <b-col
                md="12"
                v-if="
                  mData.dataDefault.listDoctor &&
                  mData.dataDefault.listDoctor.length > 0
                "
              >
                <span class="bold-500 color-black"
                  >Danh sách bác sỹ khám chữa bệnh:</span
                >
                <span v-for="bs of mData.dataDefault.listDoctor" :key="bs">
                  <p style="margin-bottom: 0">
                    &nbsp;- CCHN: {{ bs.LICENSE_CODE }}
                  </p>
                  <p style="margin-bottom: 0">
                    &nbsp;&nbsp;&nbsp;&nbsp;Họ và tên:
                    {{ bs.LAST_NAME.trim() + " " + bs.FIRST_NAME.trim() }}
                  </p>
                </span>
              </b-col>
              <b-col md="12">
                <span class="bold-500 color-black">Tình trạng ra viện:</span>
                {{
                  mData.dataForm.Benh.tinh_trang_ra_vien &&
                  mData.dataForm.Benh.tinh_trang_ra_vien[0] &&
                  mData.dataForm.Benh.tinh_trang_ra_vien[0].textTinhTrangRaVien
                    ? mData.dataForm.Benh.tinh_trang_ra_vien[0]
                        .textTinhTrangRaVien
                    : ""
                }}
              </b-col>
            </b-row>
          </b-tab>
          <b-tab style="max-height: 80vh; overflow: auto">
            <template slot="title">Tổng hợp thuốc</template>
            <div
              class="text-center"
              v-if="!loading && Object.keys(mData.dataForm.Thuoc).length == 0"
            >
              <span>Không có thông tin thuốc</span>
            </div>
            <el-timeline class="mt-1">
              <el-timeline-item
                v-for="(item, index) in mData.dataForm.Thuoc"
                :key="index"
                color="#3598DC"
                size="large"
                :timestamp="'Ngày ' + item.date"
                placement="top"
              >
                <b-row class="mt-2 ml-3">
                  <b-col
                    md="12"
                    v-for="(itemData, indexData) in item.data"
                    :key="indexData"
                  >
                    <b-col md="12" class="mt-2">
                      <span class="bold-500">Tên thuốc:</span>
                      {{ itemData.tenThuoc }}
                    </b-col>
                    <b-col md="12">
                      <span class="bold-500"
                        >Số lượng ({{ itemData.donViTinh }}):</span
                      >
                      {{ itemData.soLuong }}
                    </b-col>
                    <b-col
                      md="12"
                      class="pb-2"
                      style="border-bottom: 1px solid #e4e7ed"
                    >
                      <span class="bold-500">Liều dùng:</span>
                      {{ itemData.lieuDung }}
                    </b-col>
                  </b-col>
                </b-row>
              </el-timeline-item>
            </el-timeline>
          </b-tab>
          <b-tab style="max-height: 80vh; overflow: auto">
            <template slot="title">Tổng hợp dịch vụ kỹ thuật</template>
            <div
              class="text-center"
              v-if="!loading && Object.keys(mData.dataForm.DichVu).length == 0"
            >
              <span>Không có thông tin dịch vụ kỹ thuật</span>
            </div>
            <el-timeline class="mt-1">
              <el-timeline-item
                v-for="(item, index) in mData.dataForm.DichVu"
                :key="index"
                color="#3598DC"
                size="large"
                :timestamp="'Ngày ' + item.date"
                placement="top"
              >
                <b-row class="mt-2 ml-3">
                  <b-col
                    md="12"
                    v-for="(itemData, indexData) in item.data"
                    :key="indexData"
                  >
                    <b-col md="12" class="mt-2">
                      <span class="bold-500">Tên dịch vụ:</span>
                      {{ itemData.tenDichVu || "" }}
                    </b-col>
                    <b-col
                      md="12"
                      class="pb-2"
                      style="border-bottom: 1px solid #e4e7ed"
                    >
                      <span class="bold-500">Số lượng:</span>
                      {{ itemData.soLuong }}
                    </b-col>
                  </b-col>
                  <b-col
                    md="12"
                    class="mt-2"
                    v-if="layDuLieuXNTheoNgay(mData.dataForm.dataXN, item.date)"
                  >
                    <el-button
                      type="primary"
                      plain
                      @click="fn_DetailXN(item.date)"
                      >{{ `Chi tiết kết quả` }}</el-button
                    >
                  </b-col>
                </b-row>
              </el-timeline-item>
            </el-timeline>
          </b-tab>
          <b-tab style="max-height: 80vh; overflow: auto">
            <template slot="title">Tổng hợp phẫu thuật thủ thuật</template>
            <div
              class="text-center"
              v-if="!loading && Object.keys(mData.dataForm.Kham).length == 0"
            >
              <span>Không có thông tin phẫu thuật thủ thuật</span>
            </div>
            <el-timeline class="mt-1">
              <el-timeline-item
                v-for="(item, index) in mData.dataForm.Kham"
                :key="index"
                color="#3598DC"
                size="large"
                :timestamp="'Ngày ' + item.date"
                placement="top"
              >
                <b-row class="mt-2 ml-3">
                  <b-col
                    md="12"
                    v-for="(itemData, indexData) in item.data"
                    :key="indexData"
                  >
                    <b-col md="12" class="mt-2">
                      {{ itemData.ten }}
                    </b-col>
                  </b-col>
                </b-row>
              </el-timeline-item>
            </el-timeline>
          </b-tab>
        </b-tabs>
      </b-col>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import Hssk4210Api from "../../../moduleApi/Hssk4210Api";
import HsskHL7Api from "../../../moduleApi/HsskHL7Api";
import Hssk831Api from "../../../moduleApi/Hssk831Api";
import ApiServiceAxios from "../../../service/ApiServiceAxios";
import EhrApi from "../../../moduleApi/EhrApi";
import moment from "moment";
export default {
  props: {
    propDataForm: Object,
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      loading: false,
      mData: {
        viewMode: "",
        dialog: {
          visibleCard: false,
        },
        dataForm: {
          Benh: this.propDataForm.data,
          Thuoc: [],
          DichVu: [],
          Kham: [],
          dataXN: [],
        },
        dataDefault: {
          listDoctor: [],
        },
      },
      tabIndex: [0, 0],
    };
  },
  methods: {
    async fn_initData() {
      console.log("dataForm", this.mData.dataForm.Benh);
      if (this.propDataForm.dataTabAll) {
        this.mData.dataForm = this.fn_mergerDataHL7(
          this.propDataForm.dataTabAll
        );
      }
      if (MethodService.checkRole("Citizen")) {
        this.fn_getChiTietLanKham();
      }
      if (
        MethodService.checkRole("Hospital") ||
        MethodService.checkRole("Doctor_His")
      ) {
        this.fn_getChiTietLanKham();
      }
    },
    fn_DetailXN(selectDate) {
      let obj = {};
      this.mData.dataForm.dataXN.forEach((element) => {
        if (element.date == selectDate) {
          obj = element;
        }
      });
      this.$emit("changeData", obj);
    },
    async fn_getChiTietLanKham() {
      this.loading = true;
      let inforKCB = this.mData.dataForm.Benh;
      await this.getListDoctor();
      let token = MethodService.getToken();
      let res = await ApiServiceAxios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        url: `${inforKCB.domain}api/EHR/GetChiPhiByIDDotKhamChuaBenh?token=${token}&ApplicationCode=${window.MyConfig.applicationCode831}&IDDotKhamChuaBenh=${inforKCB.id}`,
      });
      let response = await res.data;
      this.mData.dataForm = this.fn_mergerDataHL7(response);
      this.mData.dataForm.dataXN = await this.getKQCLS();
      this.mData.dataForm.Kham = await this.fn_getPTTT();
      this.loading = false;
    },
    checkValidateDate(startDate, endDate, currentDate) {
      return (
        this.getTime(currentDate) >= this.getTime(startDate) &&
        this.getTime(currentDate) <= this.getTime(endDate)
      );
    },
    getTime(value) {
      // with dd/mm/yyyy then part[0] will be dd,
      // part[1] will be mm and part[2] will be yyyy
      var parts = value.split("/");
      // Date requires a zero referenced month
      parts[1] -= 1;
      return new Date(parts[2], parts[1], parts[0]).getTime();
    },
    fn_mergerDataHL7(item) {
      var objNew = {
        Benh: this.propDataForm.data,
        Thuoc: [],
        DichVu: [],
        Kham: [],
      };
      if (!item) {
        toastr.info("Chưa có thông tin");
        return;
      }
      let data = item;
      //for dịch vụ
      if (data.ServiceRequests && data.ServiceRequests.length > 0) {
        let dichVu = [];

        data.ServiceRequests.forEach((item) => {
          let obj = {
            date: item.Occurrence ? item.Occurrence.Value : "",
            tenDichVu:
              item.Code &&
              item.Code.Coding &&
              item.Code.Coding[0] &&
              item.Code.Coding[0].DisplayElement
                ? item.Code.Coding[0].DisplayElement.Value
                : "",
            soLuong:
              item.Quantity &&
              item.Quantity.ValueElement &&
              item.Quantity.ValueElement.Value
                ? item.Quantity.ValueElement.Value
                : "",
            dvt:
              item.Quantity && item.Quantity.UnitElement
                ? item.Quantity.UnitElement
                : "",
            khoa: item.LocationCode ? item.LocationCode : "",
            chuanDoan: item.ReasonCode ? item.ReasonCode : "",
            note: item.Note ? item.Note : "",
          };
          dichVu.push(obj);
        });

        dichVu = dichVu.filter((dv) => {
          return dv.tenDichVu != "";
        });

        let objByDate = {};
        dichVu.forEach((item) => {
          if (!objByDate[MethodService.formatDate(item.date, "date")]) {
            objByDate[MethodService.formatDate(item.date, "date")] = {
              date: MethodService.formatDate(item.date, "date"),
              data: [item],
            };
          } else {
            objByDate[MethodService.formatDate(item.date, "date")].date =
              MethodService.formatDate(item.date, "date");
            objByDate[MethodService.formatDate(item.date, "date")].data.push(
              item
            );
            objByDate[MethodService.formatDate(item.date, "date")].data.sort(
              function (a, b) {
                return a.tenDichVu.localeCompare(b.tenDichVu);
              }
            );
          }
        });
        objNew.DichVu = MethodService.sortObjectByKeyDate2(objByDate, "desc");
        if (Object.keys(objNew.DichVu).length > 0) {
          Object.keys(objNew.DichVu).forEach((elDichvu) => {
            if (
              !this.checkValidateDate(
                this.mData.dataForm.Benh.ngay_bat_dau,
                this.mData.dataForm.Benh.ngay_ket_thuc,
                elDichvu
              )
            ) {
              delete objNew.DichVu[elDichvu];
            }
          });
        }
      }

      //for thuốc
      if (data.MedicationStatements && data.MedicationStatements.length > 0) {
        let thuoc = [];

        data.MedicationStatements.forEach((item) => {
          let obj = {
            tenThuoc:
              item.Medication &&
              item.Medication.Code &&
              item.Medication.Code.Coding[0] &&
              item.Medication.Code.Coding[0].DisplayElement
                ? item.Medication.Code.Coding[0].DisplayElement.Value
                : "",
            donViTinh:
              item.Medication &&
              item.Medication.Form &&
              item.Medication.Form.Coding &&
              item.Medication.Form.Coding[0] &&
              item.Medication.Form.Coding[0].DisplayElement
                ? item.Medication.Form.Coding[0].DisplayElement.Value
                : "",
            soLuong:
              item.MedicationStatements.Dosage[0] &&
              item.MedicationStatements.Dosage[0].DoseAndRate[0].Dose.Value
                ? item.MedicationStatements.Dosage[0].DoseAndRate[0].Dose.Value
                : "",
            duongDung:
              item.MedicationStatements &&
              item.MedicationStatements.Dosage &&
              item.MedicationStatements.Dosage[0] &&
              item.MedicationStatements.Dosage[0].Route &&
              item.MedicationStatements.Dosage[0].Route.Coding &&
              item.MedicationStatements.Dosage[0].Route.Coding[0]
                ? item.MedicationStatements.Dosage[0].Route.Coding[0]
                    .DisplayElement.Value
                : "",
            lieuDung:
              item.MedicationStatements.Note[0] &&
              item.MedicationStatements.Note[0].Text
                ? item.MedicationStatements.Note[0].Text.Value
                : "",
            date:
              item.MedicationStatements.Effective &&
              item.MedicationStatements.Effective.Value
                ? item.MedicationStatements.Effective.Value
                : "",
          };
          thuoc.push(obj);
        });

        thuoc = thuoc.filter((th) => {
          return th.tenThuoc != "";
        });

        let objByDate = {};
        thuoc.forEach((item) => {
          if (!objByDate[MethodService.formatDate(item.date, "date")]) {
            objByDate[MethodService.formatDate(item.date, "date")] = {
              date: MethodService.formatDate(item.date, "date"),
              data: [item],
            };
          } else {
            objByDate[MethodService.formatDate(item.date, "date")].date =
              MethodService.formatDate(item.date, "date");
            objByDate[MethodService.formatDate(item.date, "date")].data.push(
              item
            );
            objByDate[MethodService.formatDate(item.date, "date")].data.sort(
              function (a, b) {
                return a.tenThuoc.localeCompare(b.tenThuoc);
              }
            );
          }
        });

        objNew.Thuoc = MethodService.sortObjectByKeyDate2(objByDate, "desc");
        if (Object.keys(objNew.Thuoc).length > 0) {
          Object.keys(objNew.Thuoc).forEach((elThuoc) => {
            if (
              !this.checkValidateDate(
                this.mData.dataForm.Benh.ngay_bat_dau,
                this.mData.dataForm.Benh.ngay_ket_thuc,
                elThuoc
              )
            ) {
              delete objNew.Thuoc[elThuoc];
            }
          });
        }
        console.log("objNew.Thuoc", objNew.Thuoc);
      }
      return objNew;
    },

    fn_resetForm() {
      this.mData.dataForm = {
        Benh: this.propDataForm.data,
        Thuoc: [],
        DichVu: [],
        Kham: [],
      };
    },
    async getKQCLS() {
      let token = MethodService.getToken();
      let inforKCB = this.mData.dataForm.Benh;
      const request = await fetch(
        `${inforKCB.domain}api/EHR/GetKQCLSByIDDotKhamChuaBenh?token=${token}&ApplicationCode=${window.MyConfig.applicationCode831}&IDDotKhamChuaBenh=${inforKCB.id}`,
        {
          method: "GET", // or 'PUT'
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let res = await request.json();
      let result = [];
      if (res && res.length > 0) {
        let dataXN = res;
        let days = [];
        let cache;
        let cacheXN;
        dataXN = dataXN.sort((a, b) => {
          return moment(a.Ngay, "DD/MM/YYYY") - moment(b.Ngay, "DD/MM/YYYY");
        });
        dataXN.forEach((item) => {
          if (!days.includes(item.Ngay)) {
            if (cacheXN && cache) {
              cache.result_data.push(cacheXN);
            }
            if (cache) {
              result.push(cache);
            }
            days.push(item.Ngay);
            cache = {
              date: item.Ngay,
              result_data: [],
            };
            if (item.LoaiCanLamSang == "Xét nghiệm") {
              let data = {
                type_service: item.LoaiCanLamSang,
                service_name: item.TenDichVu,
                description: item.MoTa,
                result: item.KetLuan,
              };
              data.table = [
                {
                  criteria_name: item.TenChiSo,
                  unit: item.DonVi,
                  result: item.KetQua,
                  result_: item.GiaTriBinhThuong,
                  mo_ta: item.MoTa,
                  ket_luan: item.KetLuan,
                  service_name: item.TenDichVu,
                },
              ];
              cacheXN = data;
            } else {
              let data = {
                type_service: item.LoaiCanLamSang,
                service_name: item.TenDichVu,
                description: item.MoTa,
                result: item.KetLuan,
              };
              cache.result_data.push(data);
            }
          } else {
            if (item.LoaiCanLamSang == "Xét nghiệm") {
              if (cacheXN) {
                cacheXN.table.push({
                  criteria_name: item.TenChiSo,
                  unit: item.DonVi,
                  result: item.KetQua,
                  result_: item.GiaTriBinhThuong,
                  mo_ta: item.MoTa,
                  ket_luan: item.KetLuan,
                  service_name: item.TenDichVu,
                });
              }else{
                let data = {
                  type_service: item.LoaiCanLamSang,
                  service_name: item.TenDichVu,
                  description: item.MoTa,
                  result: item.KetLuan,
                };
                data.table = [
                  {
                    criteria_name: item.TenChiSo,
                    unit: item.DonVi,
                    result: item.KetQua,
                    result_: item.GiaTriBinhThuong,
                    mo_ta: item.MoTa,
                    ket_luan: item.KetLuan,
                    service_name: item.TenDichVu,
                  },
                ];
                cacheXN = data;
              }
            } else {
              let data = {
                type_service: item.LoaiCanLamSang,
                service_name: item.TenDichVu,
                description: item.MoTa,
                result: item.KetLuan,
              };
              cache.result_data.push(data);
            }
          }
        });
        if (cacheXN && cache) {
          cache.result_data.push(cacheXN);
        }
        if (cache) {
          result.push(cache);
        }
        // result = res;
      }
      return result;
    },
    async fn_getPTTT() {
      let token = MethodService.getToken();
      let inforKCB = this.mData.dataForm.Benh;
      let request = await ApiServiceAxios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        url: `${inforKCB.domain}api/EHR/GetPTTTByIDDotKhamChuaBenh?token=${token}&ApplicationCode=${window.MyConfig.applicationCode831}&IDDotKhamChuaBenh=${inforKCB.id}`,
      });
      let response = await request.data;
      if (response && response.length > 0) {
        let kham = [];

        response.forEach((item) => {
          let obj = {
            date: item.Ngay ? item.Ngay : "",
            ten: item.TenDichVu ? item.TenDichVu : "",
            ketQua: item.KetQua ? item.KetQua : "",
          };
          kham.push(obj);
        });

        kham = kham.filter((k) => {
          return k.ten != "";
        });

        kham = kham.sort(function (a, b) {
          return (
            new Date(
              b.date.substring(6, 10),
              b.date.substring(3, 5),
              b.date.substring(0, 2)
            ) -
            new Date(
              b.date.substring(6, 10),
              b.date.substring(3, 5),
              b.date.substring(0, 2)
            )
          );
        });

        let objByDate = {};
        kham.forEach((item) => {
          if (!objByDate[item.date]) {
            objByDate[item.date] = {
              date: item.date,
              data: [item],
            };
          } else {
            objByDate[item.date].date = item.date;
            objByDate[item.date].data.push(item);
            objByDate[item.date].data.sort(function (a, b) {
              return a.ten.localeCompare(b.ten);
            });
          }
        });
        objByDate = MethodService.sortObjectByKeyDate2(objByDate, "desc");
        if (Object.keys(objByDate).length > 0) {
          Object.keys(objByDate).forEach((elPTTT) => {
            if (
              !this.checkValidateDate(
                this.mData.dataForm.Benh.ngay_bat_dau,
                this.mData.dataForm.Benh.ngay_ket_thuc,
                elPTTT
              )
            ) {
              delete objByDate[elPTTT];
            }
          });
        }
        console.log("objNew.PTTT", objByDate);
        return objByDate;
      } else {
        return {};
      }
    },
    layDuLieuXNTheoNgay(dataXN, selectDate) {
      let obj = {};
      if (dataXN && dataXN.length > 0) {
        dataXN.forEach((element) => {
          if (element.date == selectDate) {
            obj = element;
          }
        });
      }
      return Object.keys(obj).length > 0;
    },
    async getListDoctor() {
      let inforKCB = this.mData.dataForm.Benh;
      let listDoctor = [];
      try {
        if (inforKCB.danh_sach_cchn_bac_si.length > 0) {
          let resListDoctor = await EhrApi.GetListEhrDoctor(
            null,
            0,
            0,
            200,
            null,
            null,
            null,
            null
          );
          if (
            resListDoctor.data &&
            resListDoctor.data.Data &&
            resListDoctor.data.Data.length > 0
          ) {
            inforKCB.danh_sach_cchn_bac_si.forEach((element) => {
              resListDoctor.data.Data.forEach((item) => {
                if (element == item.LICENSE_CODE) {
                  listDoctor.push(item);
                }
              });
            });
          }
          console.log(listDoctor);
          this.mData.dataDefault.listDoctor = listDoctor;
        }
      } catch (error) {
        console.log("error", error);
      }
    },
  },
  computed: {},

  created: function () {
    this.fn_initData();
  },
  mounted: function () {},
  watch: {
    "$store.state.reloadModalDetailHL7": function (newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.fn_resetForm();
        this.fn_initData();
      }
    },
  },
};
</script>

<style scoped>
.tab-content.col {
  display: flex !important;
  align-items: center !important;
}
</style>